import React, { useState, useEffect } from 'react';
import LedgerTable from './ledgertable';
import constant from '../../constant';

const LedgerContent = () => {
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLedgers = async () => {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('role');
      const adminSelectedUser = localStorage.getItem('adminSelectedUser');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      let apiUrl = `${constant.REACT_APP_API_URL}/ledger`;
      if (userRole === 'admin' && adminSelectedUser) {
        apiUrl = `${constant.REACT_APP_API_URL}/ledger?userId=${adminSelectedUser}`;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          // Set ledgers to the ledgerData array, default to [] if undefined
          setLedgers(result.data.ledgerData || []);
        } else {
          setError(result.message || 'Failed to fetch items');
        }
      } catch (error) {
        setError('Error fetching items');
      } finally {
        setLoading(false);
      }
    };

    fetchLedgers();
  }, []);


  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <LedgerTable
        ledgers={ledgers}
      />
    </div>
  );
};

export default LedgerContent;